import { LocaleEnum } from 'app/constants/Enums'
import { useSession } from 'app/lib/hooks/useCurrent'
import IntlService from 'app/lib/services/IntlService'
import AppLocale from 'lngProvider'

export const useAntdMobileLocale = () => {
  // React 19 removed childContextTypes. antd-mobile LocaleProvider cannot pass locale.
  const { langCode } = useSession()
  // isLanguageValid() treats a missing locale as German, but still returns the empty langCode.
  const localeKey =
    langCode && IntlService.isLanguageValid(langCode as LocaleEnum) ? langCode : 'de'
  return AppLocale[localeKey].antMobileLocale
}
